const files = require.context('./', true, /\.vue$/i);
files.keys().map((key) => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // handle the response error
        return Promise.reject(error);
    }
);
